import React, { useState } from "react";
import { Loader, Plus } from "lucide-react";
import { toast } from "sonner";

export default function ReturnRequestsPage() {
  const [searchTerm, setSearchTerm] = useState("");

  const handleAddReturn = () => {
    toast.info("Return requests management feature coming soon");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F6EEE7] to-[#FFF5EF] p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-[#6D3A0D] mb-2">
            Return Requests
          </h1>
          <p className="text-gray-600">
            Manage customer return requests and replacements
          </p>
        </div>

        {/* Search and Filter */}
        <div className="mb-6 flex gap-4">
          <input
            type="text"
            placeholder="Search returns by order ID or customer..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="flex-1 px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#6D3A0D]"
          />
          <button
            onClick={handleAddReturn}
            className="bg-[#6D3A0D] text-white px-6 py-2 rounded-lg hover:bg-[#5a3209] flex items-center gap-2 transition"
          >
            <Plus size={20} />
            Process Return
          </button>
        </div>

        {/* Loading State */}
        <div className="bg-white rounded-lg p-8 text-center">
          <Loader className="animate-spin mx-auto mb-4 text-[#6D3A0D]" size={40} />
          <h2 className="text-2xl font-semibold text-[#6D3A0D] mb-2">
            Return Requests Management
          </h2>
          <p className="text-gray-600">
            Return requests management feature coming soon
          </p>
        </div>
      </div>
    </div>
  );
}
